/**
 * Query parameter parsing utilities.
 * Extracted to avoid circular dependencies between lib/utils.js and lib/utils/url.js.
 * No external dependencies — safe to import from anywhere.
 */

/**
 * Convert a query parameter string to an object
 * @param {string} paramString - The query parameter string (without the '?')
 * @param {Function} callback - Optional callback to transform each parameter
 * @returns {Object} Object containing all parameters as key-value pairs
 */
export function paramStringToObject(paramString, callback) {
  // PETE - 2015-06-10
  // This algorithm is pretty terrible, as I'm starting to hack it up
  // We should probably look to replace this
  const obj = {};
  const hashes = decodeURIComponent(paramString).split('&');

  for (const hash of hashes) {
    // split on = but not == because of base64
    // TODO: there has to be a better way, but because of the 2nd '='
    // character negation class, the first letter of value will go away
    // with the split, so i bring it back by wrapping it in a group
    // and join it up later
    let paramArray = hash.split(/=([^=])/);

    if (paramArray[1]) { // if there is a value
      paramArray = [paramArray[0], paramArray[1] + paramArray[2]];
    } else {
      paramArray = [paramArray[0].split(/=/)[0], ""];
    }

    if (callback) {
      paramArray = callback(paramArray[0], paramArray[1]);
    }
    obj[paramArray[0]] = paramArray[1];
  }
  return obj;
}
